export default "__VITE_ASSET__oUTbm$e3__"